import { ItemEditor as CampfireItemEditor } from "@campfirelearning/sdk-lti";
import React from "react";

import {
  CautionBanner,
  ConfirmModal,
  Modal,
  ModalProps,
} from "@examspark/common-ui";
import { TagInput } from "@examspark/types";

import ItemEditorIframed from "./ItemEditorIframed";

export type ItemEditorIframedProps = Partial<{
  itemId: string;
  onSave: (item: any) => void;
  onInit: (editor: CampfireItemEditor) => void;
  createWithTags: TagInput[];
  objectiveAuthorityIds?: string[];
}>;

/** Modal for an iframed item editor. */
const ItemEditorIframedModal = ({
  itemId,
  ...props
}: ModalProps & ItemEditorIframedProps) => {
  const [hasChanges, setHasChanges] = React.useState(false);

  const handleRequestClose = async () => {
    if (!hasChanges) {
      props.onRequestClose?.();
      return;
    }

    const isConfirmed = await ConfirmModal.show({
      children: (
        <Modal.PaddedBody>
          <CautionBanner>
            Please ensure you have saved your item before returning to the
            activity creator.
          </CautionBanner>
        </Modal.PaddedBody>
      ),
      title: "Return to Activity",
      confirmLabel: "Yes, I Saved",
    });

    if (isConfirmed) {
      props.onRequestClose?.();
    }
  };
  return (
    <Modal
      title="Item Editor"
      size="full"
      {...props}
      onRequestClose={handleRequestClose}
    >
      <ItemEditorIframed
        itemId={itemId}
        onSave={props.onSave}
        onClose={handleRequestClose}
        onChange={setHasChanges}
        onInit={props.onInit}
        createWithTags={props.createWithTags}
        objectiveAuthorityIds={props.objectiveAuthorityIds}
      />
    </Modal>
  );
};

export default ItemEditorIframedModal;
